(function () {
      if (window.JBWishlist) return;
      var STORAGE_KEY = 'jb_wishlist_v1';
      var KLAVIYO_COMPANY_ID = 'UyKadG';
      var KLAVIYO_NEWSLETTER_LIST = 'VqPtNG';

      function read() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
        catch (e) { return []; }
      }
      function write(items) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
        updateHeaderCount();
        document.dispatchEvent(new CustomEvent('jb:wishlist:change', { detail: { items: items } }));
      }
      function has(id) {
        return read().some(function (p) { return String(p.id) === String(id); });
      }
      function add(item) {
        var items = read();
        if (!items.some(function (p) { return String(p.id) === String(item.id); })) {
          items.unshift(item);
          write(items);
        }
      }
      function remove(id) {
        var items = read().filter(function (p) { return String(p.id) !== String(id); });
        write(items);
      }
      function toggle(item) {
        if (has(item.id)) { remove(item.id); return false; }
        add(item); return true;
      }
      function updateHeaderCount() {
        var count = read().length;
        document.querySelectorAll('[data-jb-wl-header]').forEach(function (el) {
          el.setAttribute('data-jb-wl-count', count);
          var bubble = el.querySelector('.jb-wishlist-header-link__bubble');
          if (bubble) bubble.textContent = count > 99 ? '99+' : count;
        });
      }
      function syncButtons() {
        document.querySelectorAll('[data-jb-wishlist-toggle]').forEach(function (btn) {
          var on = has(btn.getAttribute('data-jb-wl-id'));
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + btn.getAttribute('data-jb-wl-title') + (on ? ' from wishlist' : ' to wishlist'));
        });
      }
      function bindButtons(root) {
        (root || document).querySelectorAll('[data-jb-wishlist-toggle]:not([data-jb-bound])').forEach(function (btn) {
          btn.setAttribute('data-jb-bound', '1');
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var item = {
              id: btn.getAttribute('data-jb-wl-id'),
              handle: btn.getAttribute('data-jb-wl-handle'),
              title: btn.getAttribute('data-jb-wl-title'),
              price: btn.getAttribute('data-jb-wl-price'),
              url: btn.getAttribute('data-jb-wl-url'),
              img: btn.getAttribute('data-jb-wl-img'),
              variant: btn.getAttribute('data-jb-wl-variant'),
              available: btn.getAttribute('data-jb-wl-available') === 'true',
              added_at: Date.now()
            };
            var on = toggle(item);
            btn.classList.add('jb-wishlist-btn--pop');
            setTimeout(function () { btn.classList.remove('jb-wishlist-btn--pop'); }, 320);
            syncButtons();
            // Klaviyo event - wishlist add (optional)
            if (on) trackKlaviyo('Added to Wishlist', { product_id: item.id, product_title: item.title, product_url: item.url, price: item.price });
          });
        });
      }

      // Back-in-stock: send a Klaviyo Track event "Back In Stock Requested" via /client/events
      // Public-key client events API. https://developers.klaviyo.com/en/reference/create_client_event
      function submitBackInStock(email, product) {
        var endpoint = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID;
        var body = {
          data: {
            type: 'event',
            attributes: {
              properties: {
                product_id: product.id,
                product_title: product.title,
                variant_id: product.variant,
                product_url: location.origin + product.url,
                product_image: product.img,
                source: 'wishlist_hermes'
              },
              metric: { data: { type: 'metric', attributes: { name: 'Back In Stock Requested' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        };
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(body)
        });
      }
      // Also subscribe profile to newsletter list (consent for restock alerts implies email opt-in)
      function subscribeProfile(email, listId) {
        var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Back In Stock - Hermes',
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }}}
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(body)
        });
      }

      function trackKlaviyo(metricName, props) {
        if (!window.klaviyo) return;
        try { window.klaviyo.push(['track', metricName, props]); } catch (e) {}
      }

      function bindBis() {
        document.querySelectorAll('[data-jb-bis-form]:not([data-jb-bound])').forEach(function (form) {
          form.setAttribute('data-jb-bound', '1');
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var input = form.querySelector('[data-jb-bis-email]');
            var msg = form.querySelector('[data-jb-bis-msg]');
            var btn = form.querySelector('[data-jb-bis-btn]');
            var email = (input.value || '').trim();
            if (!email || email.indexOf('@') < 0) {
              msg.textContent = 'Please enter a valid email.';
              msg.className = 'jb-bis__msg jb-bis__msg--err';
              return;
            }
            btn.disabled = true; var originalLabel = btn.textContent; btn.textContent = 'Submitting...';
            var product = {
              id: form.getAttribute('data-jb-bis-pid'),
              title: form.getAttribute('data-jb-bis-title'),
              variant: form.getAttribute('data-jb-bis-vid'),
              url: form.getAttribute('data-jb-bis-url'),
              img: form.getAttribute('data-jb-bis-img')
            };
            Promise.all([
              submitBackInStock(email, product),
              subscribeProfile(email, KLAVIYO_NEWSLETTER_LIST)
            ]).then(function (resps) {
              msg.textContent = "You're on the list. We'll email you the moment it's back.";
              msg.className = 'jb-bis__msg jb-bis__msg--ok';
              input.value = '';
            }).catch(function () {
              msg.textContent = "Couldn't submit - try again in a moment.";
              msg.className = 'jb-bis__msg jb-bis__msg--err';
            }).then(function () {
              btn.disabled = false; btn.textContent = originalLabel;
            });
          });
        });
      }

      function init() {
        bindButtons(); syncButtons(); bindBis(); updateHeaderCount();
      }

      // Public API
      window.JBWishlist = {
        get: read, add: add, remove: remove, has: has, toggle: toggle,
        bindButtons: bindButtons, bindBis: bindBis, syncButtons: syncButtons,
        submitBackInStock: submitBackInStock
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else { init(); }

      // Re-bind after any section reload (Shopify section rendering API)
      document.addEventListener('shopify:section:load', function () { init(); });
    }());